import React, { useContext, useState } from "react";
import Manager from "../../Manager";

import FlowContext from "../../../contexts/flowContext";
import SidebarContext from "../../../contexts/sidebar";
import Navigation from "./Navigation";
import styles from "./sidebar.module.css";

const Sidebar = () => {
  const [sidebarState, dispatch] = useContext(SidebarContext);
  const [flowState, flowDispatcher] = useContext(FlowContext);

  const closeSidebar = function () {
    dispatch({
      type: "close",
      value: false,
    });
    flowDispatcher({
      type: "unselect-all-nodes",
    });
    flowDispatcher({
      type: "unselect-all-edges",
    });
  };

  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  const minSwipeDistance = 100;

  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => setTouchEnd(e.targetTouches[0].clientX);

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;
    if (isLeftSwipe || isRightSwipe)
      if (isLeftSwipe) {
        //console.log("swipe", isLeftSwipe ? "left" : "right");

        closeSidebar();
      }
  };

  return (
    <div
      className={`${styles.sidebar} ${
        sidebarState.active ? styles.active_sidebar : ""
      } sidebar
                ${sidebarState.active ? "sidebar_active" : ""}
                `}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
    >
      <Navigation />

      {<Manager />}
    </div>
  );
};

export default Sidebar;
